<template>
  <div>
    <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <!-- <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                :title="title"
                @addForm="addForm"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="3">
            <CInput
              label="Title"
              invalid-feedback="Title should be filled"
              required
              :disabled="isReadonly"
              v-model="$v.faqForm.title.$model"
              :is-valid="!$v.faqForm.title.$invalid"
            />
          </CCol>
          <CCol lg="3">
            <div class="form-group">
            <label for="status">FAQ Status</label>
            <model-select
              class="form-control"
              id="status"
              :options="StatusList"
              v-model="$v.faqForm.show.$model"
              :isError="$v.faqForm.show.$invalid"
              placeholder="-- Harap pilih salah satu --"
            ></model-select>
            <div v-if="$v.faqForm.show.$invalid" class="invalid-feedback-custom">
              Promotion Status should be filled.
            </div>
          </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="9">
            <label for="nik">Description</label>
            <quill-editor
              style="height: 200px; margin-bottom: 70px"
              :content="content"
              :options="editorOption"
              :disabled="isReadonly"
              v-model="$v.faqForm.description.$model"
              @change="onEditorChange($event)"
            >
            </quill-editor>
            <div v-if="$v.faqForm.description.$invalid" class="invalid-feedback-custom">
              Description harus di isi.
            </div>
            <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.faqForm.description.$model"
                :is-valid="!$v.faqForm.description.$invalid"
              /> -->
          </CCol>
          
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.faqForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

import Loading from "@/templates/Loading.vue";
// import TableButton from "@/templates/TableButton";
// import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Faq",
  components: { Loading, GlobalTable, quillEditor },
  data() {
    return {
      title: "Faq",
      productList: [],
      issueList: [],
      userList: [],
      StatusList: [
        { value: "1", text: "Active" },
        { value: "2", text: "Disabled" },
      ],

      // source: {
      //   localdata: [],
      //   datafields: [
      //     { name: "id", type: "number" },
      //     { name: "title", type: "string" },
      //     { name: "description", type: "string", cellsrenderer:this.linkrenderer },
      //   ],
      //   datatype: "json",
      // },
      // editrow: -1,

      fields: [
        { key: "title", label: "Title", sorter: true },
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],

      // fields: [
      //   {
      //     datafield: "title",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Title",
      //   },
      //   {
      //     datafield: "description",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Description",
      //   },
      //   {
      //     text: "Action",
      //     align: "center",
      //     name: "EditAction",
      //     columntype: "button",
      //     width: 60,
      //     sortable: false,
      //     filtertype: "none",
      //     menu: false,
      //     cellsrenderer: () => {
      //       return "Edit";
      //     },
      //     buttonclick: (row) => {
      //       let dataRecord = this.$refs.myGrid.getrowdata(row);
      //       let path = this.$route.path.split("/");

      //       this.$router.push({
      //         path: path.hasOwnProperty("2")
      //           ? path[2] + "/detail/" + dataRecord.id
      //           : "detail/" + dataRecord.id,
      //       });
      //     },
      //   },
      // ],

      items: [],
      faqForm: tableInterfaces.faq,
      isReadonly: false,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: "",
      editorOption: {}, // data quill

      showNeed:false,
      exportNeed:false,

      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    faqForm: {
      title: { required },
      description: { required },
      show: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    // exportXls: function () {
    //   this.$refs.myGrid.exportdata("xls", "order");
    // },
    // exportPdf: function () {
    //   this.$refs.myGrid.exportdata("pdf", "order");
    // },
    // myListBoxOnCheckChange: function (event) {
    //   this.$refs.myGrid.beginupdate();
    //   if (event.args.checked) {
    //     this.$refs.myGrid.showcolumn(event.args.value);
    //   } else {
    //     this.$refs.myGrid.hidecolumn(event.args.value);
    //   }
    //   this.$refs.myGrid.endupdate();
    // },
    // showHide: function () {
    //   this.visibilityShow = !this.visibilityShow;
    // },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getFaq();
    },
    getFaq: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/faq/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // const temp = this.source;
            // temp.localdata = response.data.data;
            // this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isReadonly = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.isReadonly = null;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.faqForm = item;
      if(item.show === '1') {
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.faq) {
        tableInterfaces.faq[i] = null;
      }
      this.faqForm = tableInterfaces.faq;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/faq/add", this.faqForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/faq/update", this.faqForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.faqForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
